import type { ButtonProps } from '@_/ui';
import { useSelector } from '@tanstack/react-form';
import { FormattedMessage } from 'react-intl';
import { buttonCommonI18n } from '@_/i18n-common';
import { Button } from '@_/ui';
import { useFormContext } from './BaseForm.ts';

export function FormCancelButton({ children, ...rest }: ButtonProps) {
  const form = useFormContext();

  const isSubmitting = useSelector(form.store, state => state.isSubmitting);
  const isSubmitSuccessful = useSelector(form.store, state => state.isSubmitSuccessful);

  const disabled = rest.disabled || isSubmitting || isSubmitSuccessful;

  return (
    <Button {...rest} disabled={disabled}>
      {children || <FormattedMessage {...buttonCommonI18n.cancel} />}
    </Button>
  );
}
